import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import LibMonthPicker from 'react-month-picker';

const MonthPicker = (props) => {
  const {
    onPeriodSelected, startDate, endDate, maxRange, predefinedRange,
  } = props;
  const adjustedMaxRange = maxRange - 1;

  const onChange = (year, month, listIndex) => {
    // eslint-disable-next-line no-unused-vars
    function isSameMonth(date) {
      return year === date.getFullYear() && month === date.getMonth() + 1;
    }

    function selectedStartDate() {
      const newStartDate = moment({ year, month: month - 1 });
      if (predefinedRange) {
        return predefinedRange(newStartDate);
      }
      if (startDate) {
        return {
          startDate: newStartDate.toDate(),
          endDate,
        };
      }
      return {
        startDate: newStartDate.toDate(),
        endDate: newStartDate.clone().endOf('month').toDate(),
      };
    }

    function selectedEndDate() {
      const newEndDate = moment({ year, month: month - 1 });
      if (predefinedRange) {
        return predefinedRange(newEndDate);
      }
      if (endDate) {
        return {
          startDate,
          endDate: newEndDate.endOf('month').toDate(),
        };
      }
      return {
        startDate: newEndDate.startOf('month').toDate(),
        endDate: newEndDate.clone().endOf('month').toDate(),
      };
    }

    const selectedPeriod = listIndex === 0 ? selectedStartDate() : selectedEndDate();
    onPeriodSelected(selectedPeriod);
  };
  let endSelectableRange;
  let startSelectableRange;
  if (!startDate && !endDate) {
    endSelectableRange = moment();
  } else {
    startSelectableRange = moment(endDate).subtract(adjustedMaxRange, 'months');
    const maxAfterStartDate = moment(startDate).add(adjustedMaxRange, 'months');
    endSelectableRange = maxAfterStartDate.isAfter(moment()) ? moment() : maxAfterStartDate;
  }
  const selectableRange = {
    min: startSelectableRange
      ? {
        year: startSelectableRange.year(),
        month: startSelectableRange.month() + 1,
      }
      : { year: 2000 },
    max: {
      year: endSelectableRange.year(),
      month: endSelectableRange.month() + 1,
    },
  };
  const selectedRange = {
    from: startDate
      ? {
        year: startDate.getFullYear(),
        month: startDate.getMonth() + 1,
      } : {},
    to: endDate
      ? {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
      } : {},
  };
  const lang = {
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'],
    from: 'From',
    to: 'To',
  };
  return (
    <div>
      {predefinedRange ? (
        <LibMonthPicker
          show
          lang={lang}
          theme="light"
          onChange={onChange}
          years={selectableRange}
          value={selectedRange.to}
        />
      ) : (
        <LibMonthPicker
          show
          lang={lang}
          theme="light"
          onChange={onChange}
          years={selectableRange}
          range={selectedRange}
        />
      )}

    </div>
  );
};
export default MonthPicker;

MonthPicker.propTypes = {
  onPeriodSelected: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  maxRange: PropTypes.number,
  predefinedRange: PropTypes.func,
};
